// extracted by mini-css-extract-plugin
export default {"header":"header__xBztD","logo":"logo__qX4fv","rightMenu":"rightMenu__ec0HB","action":"action__jbsql","active":"active__Yu9sC","menu":"menu__DXNcc","menuItem":"menuItem__EeIzz"};